// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

/* globals require */

// Import third party modules
import angular from 'angular';

const MODULE_NAME = 'svg';
angular.module(MODULE_NAME, [])

    .directive('appSvg', () => {
      return {
        scope: {
          svgName: '@svg',
        },
        replace: true,
        restrict: 'E',
        template: '<i class="o-svg" data-ng-include="svgUrl" aria-hidden="true" role="img"></i>',
        link: ($scope, element, attrs) => {

          if ($scope.svgName) {
            let svgUrl = '';
            try {
              svgUrl = require(`../../public/images/svgs/${ $scope.svgName }.svg`);
            } catch (e) {
            // Unable to locate SVG icon
            }
            if (svgUrl) {
              $scope.svgUrl = svgUrl;
            }
          }

        },
      };
    });

export default MODULE_NAME;
